import React, { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import AppleLogin from 'react-apple-login';
import { GoogleLogin } from 'react-google-login';
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { IconApple, IconGoogle } from '../../Icons';
import DataService from '../../services/MisDatosService';
import { RRSSData } from '../../types/PersonalData';
import { useAuthStore } from '../../store/AuthContext';
import useAPIError from '../../hooks/useAPIError';

const RedesSociales: FC = () => {
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const { addError } = useAPIError();
  const GOOGLE = 'GL';
  const FACEBOOK = 'FB';
  const APPLE = 'AP';
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const props: React.SVGProps<SVGSVGElement> = {
    className: 'facebook-vincular-margin' as string,
  };

  const [recargar, setRecargar] = useState<boolean>(false);
  const [rrssData, setRrssData] = useState<RRSSData>({
    facebookId: '',
    googleId: '',
    appleId: '',
  });
  const redirectUriApple = `${process.env.REACT_APP_BASE_URL}`;
  const recargarComponente = () => {
    setRecargar(true);
  };
  const appleCallback = (appleResponse: any) => {
    if (appleResponse.authorization && appleResponse.authorization.id_token) {
      const idToken = appleResponse.authorization.id_token;
      const idTokenArr = idToken.split('.');
      const idTokenJson = JSON.parse(atob(idTokenArr[1]));
      const json = {
        appleId: idTokenJson.sub,
      };
      DataService.vincularRrss(json).then((response) => {
        const { data } = response;
        if (!data.error) {
          recargarComponente();
        } else {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        }
      });
    }
  };

  // const facebookCallback = (facebookResponse: any) => {
  //   if (facebookResponse.id) {
  //     const json = {
  //       facebookId: facebookResponse.id,
  //     };
  //     DataService.vincularRrss(json).then((response) => {
  //       const { data } = response;
  //       if (!data.error) {
  //         recargarComponente();
  //       } else {
  //         addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
  //       }
  //     });
  //   }
  // };

  const googleCallback = (googleResponse: any) => {
    if (googleResponse.googleId) {
      const json = {
        googleId: googleResponse.googleId,
      };
      DataService.vincularRrss(json).then((response) => {
        const { data } = response;
        if (!data.error) {
          recargarComponente();
        } else {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        }
      });
    }
  };

  const handleDesvincularClick = (e: any) => {
    e.preventDefault();
    const { id } = e.target;
    let json;
    if (id) {
      switch (id) {
        default:
          json = null;
          break;
        case GOOGLE:
          json = {
            googleId: id,
          };
          break;
        case FACEBOOK:
          json = {
            facebookId: id,
          };
          break;
        case APPLE:
          json = {
            appleId: id,
          };
          break;
      }
      if (json) {
        DataService.desvincularRrss(json).then((response) => {
          const { data } = response;
          if (!data.error) {
            recargarComponente();
          } else {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
          }
        });
      }
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const componente = ('a' as unknown) as Node | React.Component<any>;
  const getData = () => {
    DataService.rrss().then((response) => {
      const { data } = response;
      if (data && data.pojo) {
        setRrssData({
          facebookId: data.pojo.facebookId,
          googleId: data.pojo.googleId,
          appleId: data.pojo.appleId,
        });
      }
    });
  };

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token]);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getData();
    }
    setRecargar(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recargar]);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);
  return (
    <>
      <div className="u-margin-bottom">
        <div className="icon-link-block u-margin-bottom-small">
          {rrssData.googleId ? (
            <>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                onClick={handleDesvincularClick}
                className="icon-link u-align-items-baseline"
              >
                <span className="icon icon-medium icon--grey ">
                  <IconGoogle />
                </span>
                <span
                  className="u-font-small u-text-brand u-text-decoration-underline"
                  id={GOOGLE}
                >
                  {t('datos.accessdata.desvincular')}
                </span>
              </a>
            </>
          ) : (
            <>
              <GoogleLogin
                clientId="277223809512-8cod3gcaq35b0q7u0kvin1lgukub6566.apps.googleusercontent.com"
                render={(renderProps) => (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    href="#"
                    onClick={renderProps.onClick}
                    className="icon-link u-align-items-baseline"
                  >
                    <span className="icon icon-medium icon--grey ">
                      <IconGoogle />
                    </span>
                    <span
                      className="u-font-small u-text-brand u-text-decoration-underline"
                      id={GOOGLE}
                    >
                      {t('datos.accessdata.vincular')}
                    </span>
                  </a>
                )}
                onSuccess={googleCallback}
                onFailure={googleCallback}
                cookiePolicy="single_host_origin"
              >
                <span
                  className="u-font-small u-text-brand u-text-decoration-underline"
                  id={GOOGLE}
                >
                  {t('datos.accessdata.vincular')}
                </span>
              </GoogleLogin>
            </>
          )}
        </div>
        {/* <div className="icon-link-block u-margin-bottom-small"> */}
        {/*  {rrssData.facebookId ? ( */}
        {/*    <> */}
        {/*      /!* eslint-disable-next-line jsx-a11y/anchor-is-valid *!/ */}
        {/*      <a */}
        {/*        href="#" */}
        {/*        onClick={handleDesvincularClick} */}
        {/*        className="icon-link u-align-items-baseline" */}
        {/*      > */}
        {/*        <IconFacebook /> */}
        {/*        <span */}
        {/*          className="u-font-small u-text-brand u-text-decoration-underline" */}
        {/*          id={FACEBOOK} */}
        {/*        > */}
        {/*          {t('datos.accessdata.desvincular')} */}
        {/*        </span> */}
        {/*      </a> */}
        {/*    </> */}
        {/*  ) : ( */}
        {/*    <> */}
        {/*      <FacebookLogin */}
        {/*        appId="1590403067868532" */}
        {/*        callback={facebookCallback} */}
        {/*        cookie */}
        {/*        xfbml */}
        {/*        // cssClass="u-font-small u-text-brand u-text-decoration-underline" */}
        {/*        // icon={<IconFacebook {...props} />} */}
        {/*        // textButton={t('datos.accessdata.vincular')} */}
        {/*        // tag={componente} */}
        {/*        render={(renderProps) => ( */}
        {/*          // eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        {/*          <a */}
        {/*            href="#acceso" */}
        {/*            onClick={renderProps.onClick} */}
        {/*            className="icon-link u-align-items-baseline" */}
        {/*          > */}
        {/*            <span className="icon icon-medium icon--grey "> */}
        {/*              <IconFacebook /> */}
        {/*            </span> */}
        {/*            <span */}
        {/*              className="u-font-small u-text-brand u-text-decoration-underline" */}
        {/*              id={FACEBOOK} */}
        {/*            > */}
        {/*              {t('datos.accessdata.vincular')} */}
        {/*            </span> */}
        {/*          </a> */}
        {/*        )} */}
        {/*      /> */}
        {/*    </> */}
        {/*  )} */}
        {/* </div> */}
        <div className="icon-link-block">
          {rrssData.appleId ? (
            <>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                onClick={handleDesvincularClick}
                className="icon-link u-align-items-baseline"
              >
                <span className="icon icon-medium icon--grey ">
                  <IconApple />
                </span>
                <span
                  className="u-font-small u-text-brand u-text-decoration-underline"
                  id={APPLE}
                >
                  {t('datos.accessdata.desvincular')}
                </span>
              </a>
            </>
          ) : (
            <>
              <AppleLogin
                clientId="www.eroski.signin"
                redirectURI={redirectUriApple}
                callback={appleCallback}
                scope="name email"
                usePopup
                render={(renderProps) => (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    href="#"
                    onClick={renderProps.onClick}
                    className="icon-link u-align-items-baseline"
                  >
                    <span className="icon icon-medium icon--grey ">
                      <IconApple />
                    </span>
                    <span
                      className="u-font-small u-text-brand u-text-decoration-underline"
                      id={APPLE}
                    >
                      {t('datos.accessdata.vincular')}
                    </span>
                  </a>
                )}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default RedesSociales;
